import { render, staticRenderFns } from "./UploadView.vue?vue&type=template&id=f67a1d6c&scoped=true"
import script from "./UploadView.vue?vue&type=script&lang=js"
export * from "./UploadView.vue?vue&type=script&lang=js"
import style0 from "./UploadView.vue?vue&type=style&index=0&id=f67a1d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a1d6c",
  null
  
)

export default component.exports